// /src/mocks/clientes.ts
import { IEmpresaCliente } from '../types';

export const mockClientes: IEmpresaCliente[] = [
  {
    id: 'empresa-1',
    nombre: 'Industrias ABC S.A.S.',
    nit: '900123456-7',
    contacto: 'Carlos Cliente - cliente@empresa1.com',
  },
  {
    id: 'empresa-2',
    nombre: 'Comercializadora XYZ Ltda.',
    nit: '800987654-3',
    contacto: 'Ana Pérez - ana.perez@xyz.com',
  },
  {
    id: 'empresa-3',
    nombre: 'Servicios Profesionales DEF',
    nit: '700456789-1',
    contacto: 'Luis Martínez - luis@def.com',
  },
];
